import { IApplicationState } from '../../types/redux';

export function getGaGeoLabel(state: IApplicationState): string {
  const {
    newbuilding: { gaLabel },
  } = state;

  return gaLabel;
}
